import React, { useRef } from 'react';

import ProjectContainer from '../containers/project-container';

interface NameProps {
    name?: string,
    loading?: boolean,
    onLoad?: () => void
}

interface ProjectNameProps {
    id: string,
    onLoad?: () => void
}

const Name = ({ name, loading, onLoad }: NameProps) => {
    const wasLoading = useRef(false);

    if (loading) {
        wasLoading.current = true;
    } else if (wasLoading.current) {
        onLoad?.();
    }

    return <>{ name || null }</>;
};

const ProjectName = ({ id, onLoad }: ProjectNameProps) => {
    return <ProjectContainer id={id}><Name onLoad={onLoad} /></ProjectContainer>;
};

export default ProjectName;
